export default function KpiCard({ icon, value, label, color = '#2952CC', onClick, style }) {
  const bg = `${color}10`;
  return (
    <div
      onClick={onClick}
      style={{
        background: 'var(--agx-surface)',
        borderRadius: '14px',
        padding: '16px',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        border: '1px solid var(--agx-border)',
        boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
        cursor: onClick ? 'pointer' : 'default',
        transition: 'transform 0.15s, box-shadow 0.15s',
        userSelect: 'none',
        flex: 1,
        minWidth: 0,
        ...style,
      }}
      onMouseEnter={(e) => {
        if (onClick) {
          e.currentTarget.style.transform = 'translateY(-2px)';
          e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.15)';
        }
      }}
      onMouseLeave={(e) => {
        if (onClick) {
          e.currentTarget.style.transform = '';
          e.currentTarget.style.boxShadow = '';
        }
      }}
    >
      <div
        style={{
          width: '40px',
          height: '40px',
          borderRadius: '12px',
          background: bg,
          color: color,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '18px',
          flexShrink: 0,
        }}
      >
        {icon}
      </div>
      <div>
        <div
          style={{ fontSize: '24px', fontWeight: 800, color: 'var(--agx-text)', lineHeight: 1.1 }}
        >
          {value}
        </div>
        <div
          style={{ fontSize: '12px', color: 'var(--agx-muted)', fontWeight: 500, marginTop: '2px' }}
        >
          {label}
        </div>
      </div>
    </div>
  );
}
